import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg } from "@/lib/api";

const AppCtx = createContext(null);

export function AppProvider({ children }) {
  const [space, setSpaceState] = useState(() => localStorage.getItem("atom-space") || "all");
  const [version, setVersion] = useState(0);
  const [dialog, setDialog] = useState(null);
  const [ticketId, setTicketId] = useState(null);
  const openTicket = useCallback((id) => setTicketId(id), []);
  const closeTicket = useCallback(() => setTicketId(null), []);

  const setSpace = (s) => {
    localStorage.setItem("atom-space", s);
    setSpaceState(s);
  };
  const refresh = useCallback(() => setVersion((v) => v + 1), []);
  const openAdd = useCallback((type, defaults = {}) => setDialog({ type, defaults }), []);
  const openEdit = useCallback((type, item) => setDialog({ type, item }), []);
  const closeDialog = useCallback(() => setDialog(null), []);

  const run = useCallback(async (fn, success) => {
    try {
      await fn();
      if (success) toast.success(success);
      refresh();
      return true;
    } catch (e) {
      toast.error(errMsg(e));
      return false;
    }
  }, [refresh]);

  useEffect(() => {
    const onKey = (e) => {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        openAdd("reminder");
      }
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [openAdd]);

  const value = { space, setSpace, version, refresh, dialog, setDialog, openAdd, openEdit, closeDialog, run, ticketId, openTicket, closeTicket };
  return <AppCtx.Provider value={value}>{children}</AppCtx.Provider>;
}

export const useApp = () => useContext(AppCtx);
